module.exports = __webpack_public_path__ + "static/media/4.4a602d3b.jpg";